import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { List } from 'immutable'
import SelectList from 'components/common/SelectList'
import {
  setActiveProductions,
  clearProductionAndHealthData,
} from 'reducers/dataBrowser/reducer'
import * as TYPE from 'constants/requestTypes'
import messages from '../../translate'

class ProdAndHealth extends Component {
  constructor(props) {
    super(props)
    const {
      intl: { formatMessage },
    } = props
    this.prodAndHealthList = [
      { value: 0, name: formatMessage(messages.unselectAll) },
      { value: TYPE.DB_FISH_COUNT, name: formatMessage(messages.fishCount) },
      {
        value: TYPE.DB_AVERAGE_WEIGHT,
        name: formatMessage(messages.averageWeight),
      },
      { value: TYPE.DB_BIOMASS, name: formatMessage(messages.biomass) },
      {
        value: TYPE.DB_MORTALITY_COUNT,
        name: formatMessage(messages.mortalityCount),
      },
      { value: TYPE.DB_MORTALITY, name: formatMessage(messages.mortality) },
    ]
  }

  onProductChange = data => {
    const {
      activeProds,
      setActiveProductions,
      clearProductionAndHealthData,
    } = this.props

    if (!!data && data.index !== activeProds.get('value')) {
      if (data.index !== 0) {
        setActiveProductions(data.item)
      } else {
        clearProductionAndHealthData()
      }
    }
  }

  render() {
    const {
      intl: { formatMessage },
      activeProds,
    } = this.props

    return (
      <SelectList
        name="prod_and_health"
        label={formatMessage(messages.prodAnHealth)}
        onChange={this.onProductChange}
        list={List(this.prodAndHealthList)}
        value={activeProds.get('value')}
        map={{
          index: 'value',
          text: 'name',
        }}
      />
    )
  }
}

export default connect(
  state => ({
    activeProds: state.getIn(['dataBrowser', 'activeProductions']),
  }),
  {
    setActiveProductions,
    clearProductionAndHealthData,
  },
)(injectIntl(ProdAndHealth))
